export const defaultSortByGlobal = [{ id: 'id', desc: true }];
export const PAGE_SIZES = [10, 25, 50, 100];
export const DEFAULT_PAGINATION_RESPONSE: { total: number } = { total: 0 };
export const contextSearchFilter = { search: '' };
